<template>
    <b-card class="m-1" body-class="d-flex flex-column justify-content-center align-items-center">
        <b-img fluid width="300" :src="img" class="m-3"/>
        <h3 class="text-danger my-2 text-center">Ödeme sırasında hata oluştu!</h3>
        <h5 class="text-primary text-center" :v-if="errorDetail1 != null">Banka Hata Mesajı - 1: {{ errorDetail1 }} </h5>
        <h5 class="text-primary text-center mb-1"  :v-if="errorDetail2 != null">Banka Hata Mesajı - 2: {{ errorDetail2 }}</h5>
        <p>Yapmak istediğiniz ödeme başarısız şekilde sonuçlandı. </p> 
        <p>Hata mesajlarında yer alan bilgilere istinaden işleminizi yeniden deneyebilirsiniz.</p>
        <p>Eğer hata mesajlarında problem olduğunu düşünüyorsanız satış temsilciniz ile iletişime geçebilirsiniz.</p>
        <button class="btn btn-primary" v-on:click="goPayment">Tahsilat Ekranına Dön</button>
    </b-card>
</template>

<script>
import { BCard,BImg } from 'bootstrap-vue'
import { PaymentApi } from '@/api/payment'
export default {
    components:{
        BCard,
        BImg,
    },
    data() {
        return {
            groupCode:this.$route.params?.groupCode || null,
            receiptCode:this.$route.params?.receiptCode || null,
            img:require('@/assets/images/illustrations/payment-error.svg'),
            errorDetail1:null,
            errorDetail2:null
        }
    },
    mounted(){
        this.errorDetail()
    },
    methods:{
        goPayment(){
            this.$router.push({name:'payment',params:{code:this.groupCode}})
        },
        errorDetail(){
            PaymentApi.ErrorDetail(this.groupCode,this.receiptCode).then(res=>{
                if(res.data.Success){
                    this.errorDetail1 = res.data.Data.ErrorDetail1
                    this.errorDetail2 = res.data.Data.ErrorDetail2
                }
            })
        }
    }
}
</script>

<style>

</style>